export const WEEK_CREATE_REQUEST = 'WEEK_CREATE_REQUEST';
export const WEEK_CREATE_SUCCESS = 'WEEK_CREATE_SUCCESS';
export const WEEK_CREATE_FAIL = 'WEEK_CREATE_FAIL';

export const WEEK_LIST_REQUEST = 'WEEK_LIST_REQUEST';
export const WEEK_LIST_SUCCESS = 'WEEK_LIST_SUCCESS';
export const WEEK_LIST_FAIL = 'WEEK_LIST_FAIL';

export const WEEK_LIST_DELETE_REQUEST = 'WEEK_LIST_DELETE_REQUEST';
export const WEEK_LIST_DELETE_SUCCESS = 'WEEK_LIST_DELETE_SUCCESS';
export const WEEK_LIST_DELETE_FAIL = 'WEEK_LIST_DELETE_FAIL';

export const WEEK_LIST_APPEND_REQUEST = 'WEEK_LIST_APPEND_REQUEST';
export const WEEK_LIST_APPEND_SUCCESS = 'WEEK_LIST_APPEND_SUCCESS';
export const WEEK_LIST_APPEND_FAIL = 'WEEK_LIST_APPEND_FAIL';

export const WEEK_DETAILS_REQUEST = 'WEEK_DETAILS_REQUEST';
export const WEEK_DETAILS_SUCCESS = 'WEEK_DETAILS_SUCCESS';
export const WEEK_DETAILS_FAIL = 'WEEK_DETAILS_FAIL';

export const WEEK_DELETE_REQUEST = 'WEEK_DELETE_REQUEST';
export const WEEK_DELETE_SUCCESS = 'WEEK_DELETE_SUCCESS';
export const WEEK_DELETE_FAIL = 'WEEK_DELETE_FAIL';

export const WEEK_UPDATE_REQUEST = 'WEEK_UPDATE_REQUEST';
export const WEEK_UPDATE_SUCCESS = 'WEEK_UPDATE_SUCCESS';
export const WEEK_UPDATE_FAIL = 'WEEK_UPDATE_FAIL';

export const WEEK_UPDATE_BY_DAY_REQUEST = 'WEEK_UPDATE_BY_DAY_REQUEST';
export const WEEK_UPDATE_BY_DAY_SUCCESS = 'WEEK_UPDATE_BY_DAY_SUCCESS';
export const WEEK_UPDATE_BY_DAY_FAIL = 'WEEK_UPDATE_BY_DAY_FAIL';
